export default class Select {
    constructor(props) {
        let self = this;

        if(props.hasOwnProperty('selector')) {
            $(props.selector).each((index, el) => {
                self.toggleSelect($(el), $(el).find('.configurator-select-dropdown .selected'));

                if($(el).is('.style-image')) {
                    $(document).trigger('sort-taber:init', {id: $(el).attr('id'), list: $(el).find('.list')});
                }
            });
        }

        $(document).on('click', '.configurator-select-selected', function () {
            let $selected = $(this);
            let $selectedArrow = $selected.find('.brand-icon');
            let $select = $selected.closest('.configurator-select');
            let $dropdown = $select.find('.configurator-select-dropdown');

            if($select.is('.open')) {
                self.close($select, $selectedArrow, $dropdown);
            }else {
                self.open($select, $selectedArrow, $dropdown);
            }

            return false;
        }).on('click', '.configurator-select-dropdown .list .item', function () {
            self.toggleSelect($(this).closest('.configurator-select'), $(this));

            if($(this).is('.text_color')) {
                let style = $(this).find('.color').attr('style');
                let color = style.replace('background: ', '');
                let border = 'none';
                let $textColorPreview = $('#configurator_select_text_color .example .color');

                if(color.toUpperCase() === '#FFFFFF' || color.toUpperCase() === '#FFF') {
                    color = '#D3D3D3';
                    border = '1px solid #a9a9a9';
                }

                $('.font-preview, .configurator-select-dropdown .fonts .label').css({
                    'color': color
                });

                $textColorPreview.css({
                    border: border
                });
            }

            return false;
        }).on('click', '.configurator-select-close', function () {
            let $select = $(this).closest('.configurator-select');
            let $selectedArrow = $select.find('.configurator-select-selected .brand-icon');
            let $dropdown = $select.find('.configurator-select-dropdown');

            self.close($select, $selectedArrow, $dropdown);

            return false;
        });
    }

    toggleSelect($select, $selected) {
        let selectedValue = $selected.attr('data-value');
        let $input = $select.find('input');
        let $dropdownItems = $select.find('.configurator-select-dropdown .item');

        $dropdownItems.each(function (index, el) {
            let $item = $(el);
            let value = $item.attr('data-value');

            if(selectedValue !== value) {
                $item.removeClass('selected');
            }else {
                let $label = $select.find('.configurator-select-selected .label');
                let $fontPreview = $select.find('.configurator-select-selected .font-preview');
                let $imagePreview = $select.find('.configurator-select-selected .image-preview .example');
                let $figure = $item.find('.figure');
                let style = $item.attr('style');
                let key = $select.find('input').attr('name');
                let previewValue = null;

                $selected.addClass('selected');

                if(style && $fontPreview.length) {
                    let fontFamily = style.replace('font-family: ', '')

                    $fontPreview.css({
                        'font-family': fontFamily
                    });

                    previewValue = fontFamily;
                }

                if($figure.length) {
                    $label.find('.figure').remove();
                    $label.append($figure.clone());

                    previewValue = $figure.attr('class').split(' ')[1];
                }

                if($imagePreview.length) {
                    let $img = $item.find('img');
                    let html = '';

                    if($img.length) {
                        html = $img.clone();
                        previewValue = $img.attr('src');
                        let borderColor = $img.attr('data-border-color');

                        if(typeof borderColor === 'undefined' || !borderColor.includes('#')) {
                            borderColor = null;
                        }

                        $(document).trigger('configurator-select:selected-border-color', borderColor);
                    }else {
                        let $color = $item.find('.color');

                        if($color.length) {
                            let color = $color.attr('style');

                            html = `<div class="color" style="${color}"></div>`;
                            previewValue = color.replace('background: ', '');
                        }
                    }

                    $imagePreview.html(html);
                }

                if($select.is('#configurator_select_price')) {
                    let $left = $item.find('.left-label').clone();
                    let amount = $item.attr('data-value');
                    let price = $item.attr('data-price');
                    let payload = {key, price, amount};
                    let $wrapper = $('<div class="value"></div>');

                    $label.html($left);
                    $label.append($wrapper);

                    if($item.find('del').length) {
                        let $del = $item.find('del').clone();
                        let $ins = $item.find('ins').clone();

                        $label.find('.value').append($del);
                        $label.find('.value').append($ins);
                    }else {
                        let $amount = $item.find('.amount').clone();

                        $label.find('.value').append($amount);
                    }

                    $(document).trigger('configurator-select:selected-price', payload);
                }

                $input.val(selectedValue);
                $(document).trigger('configurator-select:selected', {key, value: previewValue});
            }
        });
    }

    open($select, $selectedArrow, $dropdown) {
        this.closeAllOthers($select);
        $select.addClass('open');
        $selectedArrow.removeClass('ill-angle-down').addClass('ill-angle-up');
        $dropdown.stop(true, true).slideDown(500);
    }

    close($select, $selectedArrow, $dropdown) {
        $select.removeClass('open');
        $selectedArrow.removeClass('ill-angle-up').addClass('ill-angle-down');
        $dropdown.stop(true, true).slideUp(500);
    }

    closeAllOthers($select) {
        let self = this;
        let selectId = $select.attr('id');

        $('.configurator-select.open').each(function (index, el) {
            let id = $(el).attr('id');

            if(id !== selectId) {
                let $select = $(el);
                let $selectedArrow = $select.find('.configurator-select-selected .brand-icon');
                let $dropdown = $select.find('.configurator-select-dropdown');

                self.close($select, $selectedArrow, $dropdown);
            }
        });
    }
}